import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { useMediaQuery } from '@react-hook/media-query';
import { mediaQuery } from '@modernhealth/vital-foundation';
import { pxToRem } from '../../helpers/pxToRem';
import { DeprecatedReactRouterLink as Link } from '../Link/DeprecatedReactRouterLink';
import { BodyTextXSmall, ComponentTextSmall, HeadingText30, HeadingText40, } from '../Typography/Typography';
import { SkeletonPlaceholder } from '../Skeleton/SkeletonPlaceholder';
export var SectionHeaderTestID;
(function (SectionHeaderTestID) {
    SectionHeaderTestID["Container"] = "SectionHeaderTestID.Container";
    SectionHeaderTestID["SecondaryTextButton"] = "SectionHeaderTestID.SecondaryTextButton";
})(SectionHeaderTestID || (SectionHeaderTestID = {}));
const Name = 'SectionHeader';
export const SectionHeader = ({ title, secondaryText, secondaryTextLink, onSecondaryTextPress, noMarginTop = false, }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const shouldShowSecondaryTextButton = secondaryText && (onSecondaryTextPress || secondaryTextLink);
    const TextComponent = smallScreenDetected ? HeadingText30 : HeadingText40;
    const SecondaryTextComponent = smallScreenDetected
        ? BodyTextXSmall
        : ComponentTextSmall;
    return (_jsxs(Container, { noMarginTop: noMarginTop, "data-component": Name, "data-testid": SectionHeaderTestID.Container, children: [_jsx(TextComponent, { marginBottom: 0, children: title }), shouldShowSecondaryTextButton &&
                (secondaryTextLink ? (_jsx(Link, { to: secondaryTextLink, "data-testid": SectionHeaderTestID.SecondaryTextButton, children: _jsx(SecondaryTextComponent, { fontColor: "blue55", marginTop: 3, children: secondaryText }) })) : (_jsx(SecondaryTextButton, { onClick: onSecondaryTextPress, "data-testid": SectionHeaderTestID.SecondaryTextButton, children: _jsx(SecondaryTextComponent, { fontColor: "blue55", marginTop: 3, children: secondaryText }) })))] }));
};
export const SectionHeaderSkeleton = ({ showSecondaryButton, noMarginTop = false, }) => (_jsxs(Container, { noMarginTop: noMarginTop, children: [_jsx(SkeletonPlaceholder, { width: 180, height: 25, borderRadius: 4 }), showSecondaryButton && (_jsx(SkeletonPlaceholder, { width: 50, height: 25, borderRadius: 4 }))] }));
const Container = styled.div(({ noMarginTop }) => ({
    marginBottom: pxToRem(20),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    marginTop: noMarginTop ? 0 : pxToRem(48),
    [mediaQuery.maxWidth('xl')]: {
        marginTop: noMarginTop ? 0 : pxToRem(24),
    },
}));
const SecondaryTextButton = styled.div({
    height: '100%',
    cursor: 'pointer',
});
